import { SYSTEM_MANAGED_DATA_NODE } from "@lifeat/shared/rtdb-nodes/RtdbNodes";
import { db } from "@firebase-local/firebase";
import { logError, logWarn } from "@service/ConsoleLoggerService";

export const fetchDailyFortune = (callback: (fortuneStr: string) => void) => {
    // Path: /systemManagedData/widgets/dailyFortune
    const dbPath =
        `/${SYSTEM_MANAGED_DATA_NODE.name}` +
        `/${SYSTEM_MANAGED_DATA_NODE.children.WIDGETS.name}` +
        `/${SYSTEM_MANAGED_DATA_NODE.children.WIDGETS.children.DAILY_FORTUNE_STR}`;

    db.ref(dbPath)
        .get()
        .then((snapshot) => {
            if (snapshot.exists()) {
                callback(snapshot.val());
            } else {
                logWarn("No data found for daily fortune.");
            }
        })
        .catch((error) => {
            logError(error);
        });
};
